// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css */
.cure-rooms-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f8f9fa;
  font-family: Arial, sans-serif;
}

.selection-panel {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

.selection-section {
  width: 48%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  max-height: 200px;
  overflow-y: auto;
}

.selection-section h4 {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
}

.checkbox-group {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.checkbox-group label {
  margin-left: 8px;
  font-size: 16px;
}

.button-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
}

.btn-primary {
  background-color: #007bff;
  color: #fff;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.data-display {
  width: 100%;
  max-width: 800px;
}

.facility-box {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
}

.facility-box h3 {
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 700;
}

.room-box {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f7f7f7;
}

.room-box h4 {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
}

.location-box {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #e9ecef;
}

.location-box h5 {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
}

.location-details p,
.strain-details p {
  margin: 2px 0;
  font-size: 14px;
}

@media (max-width: 844px) {
  .facility_room_box_container {
    display: flex;
    flex-wrap: wrap;
  }
  .facility_room_box {
    width: 100% !important;
    margin-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/cure/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["/* index.css */\n.cure-rooms-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  background-color: #f8f9fa;\n  font-family: Arial, sans-serif;\n}\n\n.selection-panel {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 800px;\n  margin-bottom: 20px;\n}\n\n.selection-section {\n  width: 48%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.selection-section h4 {\n  margin-bottom: 10px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.checkbox-group {\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-group label {\n  margin-left: 8px;\n  font-size: 16px;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: #fff;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n}\n\n.data-display {\n  width: 100%;\n  max-width: 800px;\n}\n\n.facility-box {\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n}\n\n.facility-box h3 {\n  margin-bottom: 15px;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.room-box {\n  margin-bottom: 15px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f7f7f7;\n}\n\n.room-box h4 {\n  margin-bottom: 10px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.location-box {\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #e9ecef;\n}\n\n.location-box h5 {\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.location-details p,\n.strain-details p {\n  margin: 2px 0;\n  font-size: 14px;\n}\n\n@media (max-width: 844px) {\n  .facility_room_box_container {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .facility_room_box {\n    width: 100% !important;\n    margin-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
